/* eslint-disable react/display-name */
/* eslint-disable no-undef */
import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../common/';
import { processIconWidgetTemplate } from '../../common/utilities/forecastIconUrlUtils';
import { getWeatherWidgetForecastIconAction } from '../../common/actions/weatherWidgetsActions';

interface ForecastIconProps {
    iconSet: string;
    iconSize: string;
    authId: string;
    secret: string;
    contentManagementBaseUrl: string;
    stdParameters: object;
    resourceList: string;
    iconCode: number;
    forecastIconUrl: string;
    currentForecastUnits: string;
    currentTemperature: string;
    getWeatherWidgetForecastIconAction(contentManagementBaseUrl: string, authId: string, secret: string, resourceList: string, stdParameters?: object): void;
}

const mapStoreStateToProps = (storeState: any) => {
    const appState = storeState?.appState?.appState || {};
    const { authId, secret, forecastIconResourceList, forecastIconSize, forecastIconSet, contentMgmtBaseUrl, stdParameters } = appState;
    const { weatherWidget } = storeState || {};
    const { forecastIconUrl, iconCode } = weatherWidget || {};

    return {
        authId,
        secret,
        stdParameters,
        iconSet: forecastIconSet,
        iconSize: forecastIconSize,
        contentManagementBaseUrl: contentMgmtBaseUrl,
        resourceList: forecastIconResourceList,
        forecastIconUrl,
        iconCode
    };
};

const mapDispatchToProps = {
    getWeatherWidgetForecastIconAction
};

export const ForecastIcon = reduxConnect( mapStoreStateToProps, mapDispatchToProps )(memo((
    { 
        iconSet,
        iconSize,
        iconCode = 999, // default error icon code
        authId,
        secret,
        contentManagementBaseUrl,
        stdParameters = {},
        resourceList,
        forecastIconUrl,
        getWeatherWidgetForecastIconAction
    } : ForecastIconProps
) => {
    
    const [forecastIconSrc, setForecastIconSrc] = useState<string>('');
    const didFetchIcon = useRef<boolean>(false);

    const fetchIcon = useCallback(() => {
        if (authId && secret && contentManagementBaseUrl &&  resourceList) {
            getWeatherWidgetForecastIconAction(contentManagementBaseUrl, authId, secret, resourceList, stdParameters);
            didFetchIcon.current = true;
        }
    }, [authId, secret, contentManagementBaseUrl, resourceList]);

    useEffect(() => {
        if (!didFetchIcon.current) {
            fetchIcon(); 
        }
    }, [fetchIcon, didFetchIcon.current]);

    useEffect(() => {
        if (forecastIconUrl && iconSize && iconCode && iconSet && didFetchIcon.current) {
            const iconImageSrc = processIconWidgetTemplate(iconCode, iconSize, iconSet, forecastIconUrl);
            setForecastIconSrc(iconImageSrc);
        }
    }, [forecastIconUrl, iconCode, iconSet, iconSize]);

    return (
        <ForecastIconImageContainer src={forecastIconSrc} />
    );
}));

ForecastIcon.displayName = 'ForecastIcon';

const ForecastIconImageContainer = styled.img`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
`;